import { andTheme } from '../../../styles/theme'

export default {
  selected: {
    border: `3px solid ${andTheme.colours.black}`,
    fontWeight: 700
  },
  indicator: {
    color: 'black',
    fontWeight: 700,
    backgroundColor: 'white',
    padding: '10px 20px',
    left: '-3px',
    top: '-8px',
    filter: `drop-shadow(1px 1px 1px ${andTheme.colours.black})`
  },
  calendarBase: {
    padding: '12px 20px 15px',
    marginBottom: '50px',
    borderRadius: 20,
    boxShadow: andTheme.boxShadow
  },
  calendarHeader: {
    margin: '0 0 12px',
    [`@media (min-width: ${andTheme.breakpoints.lg}px)`]: {
      margin: '0 50px 12px'
    }
  },
  calendarHeaderControl: {
    color: andTheme.colours.black,
    svg: {
      height: 23,
      width: 23,
      stroke: andTheme.colours.black,
      strokeWidth: 0.25
    }
  },
  calendarHeaderLevel: {
    fontFamily: 'Poppins',
    fontWeight: 500,
    fontSize: '16px',
    lineHeight: '24px',
    [`@media (min-width: ${andTheme.breakpoints.xl}px)`]: {
      fontSize: '18px',
      lineHeight: '36px'
    }
  },
  weekday: {
    color: andTheme.colours.black,
    fontSize: '14px',
    [`@media (min-width: ${andTheme.breakpoints.lg}px)`]: {
      fontSize: '18px'
    }
  },
  day: {
    margin: 'auto',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'stretch',
    alignContent: 'stretch',
    borderRadius: '50%',
    fontFamily: 'Inter',
    fontWeight: 400,
    fontSize: '18px',
    lineHeight: '22px',
    color: 'white',
    width: '90%',
    maxWidth: '50px',
    aspectRatio: '1 / 1',
    height: 'auto',
    [`@media (min-width: ${andTheme.breakpoints.lg}px)`]: {
      fontSize: '18px',
      lineHeight: '29px'
    },
    '& > :first-of-type': {
      flex: 1,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    },
    '&.__mantine-ref-outside': {
      color: 'white!important',
      '&:disabled': {
        color: '#ced4da!important'
      }
    }
  },
  cell: {
    paddingBottom: '5px',
    [`@media (min-width: ${andTheme.breakpoints.lg}px)`]: {
      paddingBottom: '8px'
    }
  }
}
